export const parseBookingDate = (rawDate: string): Date => {
  const dateValue = String(rawDate || "").trim();

  if (!dateValue) {
    return new Date(NaN);
  }

  // Known booking format in DB: DD/MM/YYYY
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateValue)) {
    const [day, month, year] = dateValue.split("/");
    return new Date(`${year}-${month}-${day}T00:00:00`);
  }

  // Fallback for ISO and other date-like values
  return new Date(dateValue);
};
